package org.multipaz.utopia.generated

/**
 * Generated strings for language: uk
 * DO NOT EDIT - This file is auto-generated by the generateMultipazStrings task
 */
internal val strings_uk = mapOf(
    "boarding_pass_attribute_departure_time" to "Час відправлення",
    "boarding_pass_attribute_flight_number" to "Номер рейсу",
    "boarding_pass_attribute_passenger_name" to "Ім'я пасажира",
    "boarding_pass_attribute_seat_number" to "Номер місця",
    "boarding_pass_description_departure_time" to "Дата та час відправлення",
    "boarding_pass_description_flight_number" to "Номер рейсу",
    "boarding_pass_description_passenger_name" to "Прізвище або основний ідентифікатор власника mDL.",
    "boarding_pass_description_seat_number" to "Номер місця",
    "cor_attribute_administrative_number" to "Адміністративний номер",
    "cor_attribute_date_of_arrival" to "Дата прибуття",
    "cor_attribute_date_of_birth" to "Дата народження",
    "cor_attribute_date_of_expiry" to "Дата закінчення терміну дії",
    "cor_attribute_date_of_issue" to "Дата видачі",
    "cor_attribute_document_number" to "Номер документа",
    "cor_attribute_family_name" to "Прізвище",
    "cor_attribute_gender" to "Стать",
    "cor_attribute_given_names" to "Ім'я",
    "cor_attribute_issuing_authority" to "Орган, що видав",
    "cor_attribute_issuing_country" to "Країна видачі",
    "cor_attribute_issuing_jurisdiction" to "Юрисдикція видачі",
    "cor_attribute_nationality" to "Громадянство",
    "cor_attribute_older_than_18" to "Старше 18 років",
    "cor_attribute_older_than_21" to "Старше 21 року",
    "cor_attribute_place_of_birth" to "Місце народження",
    "cor_attribute_resident_address" to "Адреса проживання",
    "cor_attribute_resident_city" to "Місто проживання",
    "cor_attribute_resident_country" to "Країна проживання",
    "cor_attribute_resident_house_number" to "Номер будинку проживання",
    "cor_attribute_resident_postal_code" to "Поштовий індекс проживання",
    "cor_attribute_resident_state" to "Штат проживання",
    "cor_attribute_resident_street" to "Вулиця проживання",
    "cor_description_administrative_number" to "Номер, присвоєний постачальником COR для аудиторського контролю або інших цілей.",
    "cor_description_date_of_arrival" to "День, місяць і рік прибуття власника COR до ЄС.",
    "cor_description_date_of_birth" to "День, місяць і рік народження власника COR. Якщо невідомо, приблизна дата народження.",
    "cor_description_date_of_expiry" to "Дата (і, можливо, час) закінчення терміну дії COR.",
    "cor_description_date_of_issue" to "Дата (і, можливо, час) видачі COR.",
    "cor_description_document_number" to "Номер COR, призначений постачальником COR.",
    "cor_description_family_name" to "Поточне прізвище(а) або основний ідентифікатор власника COR",
    "cor_description_gender" to "Стать власника COR.",
    "cor_description_given_names" to "Поточне ім'я(ена), інші імена або додатковий ідентифікатор власника COR",
    "cor_description_issuing_authority" to "Назва адміністративного органу, що видав цей екземпляр COR, або двобуквений код країни за ISO 3166 відповідної держави-члена, якщо немає окремого органу, уповноваженого видавати COR.",
    "cor_description_issuing_country" to "Двобуквений код країни, як визначено в ISO 3166-1, країни або території органу, що видав документ.",
    "cor_description_issuing_jurisdiction" to "Код підрозділу країни юрисдикції, що видала COR, як визначено в ISO 3166-2:2020, Розділ 8. Перша частина коду ПОВИННА збігатися зі значенням issuing_country.",
    "cor_description_nationality" to "Дволітерний код країни згідно з ISO 3166-1, що вказує на національність користувача.",
    "cor_description_older_than_18" to "Старше 18 років?",
    "cor_description_older_than_21" to "Старше 21 року?",
    "cor_description_place_of_birth" to "Місце, де власник COR народився.",
    "cor_description_resident_address" to "Повна адреса місця поточного проживання власника COR та/або за якою можна зв'язатися (вулиця/номер будинку, населений пункт тощо)",
    "cor_description_resident_city" to "Місто, де власник COR наразі проживає.",
    "cor_description_resident_country" to "Країна поточного проживання користувача у форматі дволітерного коду країни згідно з ISO 3166-1",
    "cor_description_resident_house_number" to "Номер будинку, де користувач наразі проживає, включно з будь-яким префіксом або суфіксом.",
    "cor_description_resident_postal_code" to "Поштовий індекс місця, де власник COR наразі проживає.",
    "cor_description_resident_state" to "Область, провінція, район або місцевість, де користувач наразі проживає.",
    "cor_description_resident_street" to "Назва вулиці, де користувач наразі проживає.",
    "cor_request_age_over_18" to "Вік старше 18 років",
    "cor_request_all_data_elements" to "Усі елементи даних",
    "cor_request_mandatory_data_elements" to "Обов'язкові елементи даних",
    "document_display_name_boarding_pass" to "Посадковий талон",
    "document_display_name_certificate_of_residency" to "Свідоцтво про реєстрацію місця проживання",
    "document_display_name_german_personal_id" to "Німецьке посвідчення особи",
    "document_display_name_loyalty_card" to "Картка лояльності",
    "document_display_name_movie_ticket" to "Квиток у кіно",
    "document_display_name_naturalization_certificate" to "Свідоцтво про натуралізацію",
    "document_display_name_payment_card" to "Платіжна картка",
    "german_id_attribute_administrative_number" to "Адміністративний номер",
    "german_id_attribute_age_in_years" to "Вік (у роках)",
    "german_id_attribute_city_of_birth" to "Місто народження",
    "german_id_attribute_country_of_birth" to "Країна народження",
    "german_id_attribute_date_of_birth" to "Дата народження",
    "german_id_attribute_date_of_expiry" to "Дата закінчення терміну дії",
    "german_id_attribute_date_of_issue" to "Дата видачі",
    "german_id_attribute_document_number" to "Номер документа",
    "german_id_attribute_family_name" to "Прізвище",
    "german_id_attribute_family_name_at_birth" to "Прізвище при народженні",
    "german_id_attribute_gender" to "Стать",
    "german_id_attribute_given_names" to "Імена",
    "german_id_attribute_issuing_authority" to "Орган, що видав",
    "german_id_attribute_issuing_country" to "Країна видачі",
    "german_id_attribute_issuing_jurisdiction" to "Юрисдикція видачі",
    "german_id_attribute_nationality" to "Громадянство",
    "german_id_attribute_older_than_12" to "Старше 12 років",
    "german_id_attribute_older_than_14" to "Старше 14 років",
    "german_id_attribute_older_than_16" to "Старше 16",
    "german_id_attribute_older_than_18" to "Старше 18",
    "german_id_attribute_older_than_21" to "Старше 21",
    "german_id_attribute_older_than_65" to "Старше 65",
    "german_id_attribute_place_of_birth" to "Місце народження",
    "german_id_attribute_resident_address" to "Адреса проживання",
    "german_id_attribute_resident_city" to "Місто проживання",
    "german_id_attribute_resident_country" to "Країна проживання",
    "german_id_attribute_resident_postal_code" to "Поштовий індекс проживання",
    "german_id_attribute_state_of_birth" to "Штат народження",
    "german_id_attribute_year_of_birth" to "Рік народження",
    "german_id_description_administrative_number" to "Номер, призначений Постачальником PID для аудиторського контролю або інших цілей.",
    "german_id_description_age_in_years" to "Вік власника PID у роках",
    "german_id_description_city_of_birth" to "Муніципалітет, місто, селище або село, де народився користувач PID.",
    "german_id_description_country_of_birth" to "Країна, де народився користувач PID, у вигляді дволітерного коду країни згідно з ISO 3166-1",
    "german_id_description_date_of_birth" to "День, місяць і рік народження власника PID. Якщо невідомо, приблизна дата народження.",
    "german_id_description_date_of_expiry" to "Дата (і, можливо, час) закінчення терміну дії PID.",
    "german_id_description_date_of_issue" to "Дата (і, можливо, час) видачі PID.",
    "german_id_description_document_number" to "Номер для PID, призначений Постачальником PID.",
    "german_id_description_family_name" to "Поточне прізвище (прізвища) або основний ідентифікатор власника PID",
    "german_id_description_family_name_at_birth" to "Прізвище(а) або основний ідентифікатор власника PID при народженні",
    "german_id_description_gender" to "Стать власника PID.",
    "german_id_description_given_names" to "Поточне ім'я (імена), інші імена або вторинний ідентифікатор власника PID",
    "german_id_description_issuing_authority" to "Назва адміністративного органу, який видав цей екземпляр PID, або дволітерний код країни ISO 3166 відповідної держави-члена, якщо немає окремого органу, уповноваженого видавати PID.",
    "german_id_description_issuing_country" to "Дволітерний код країни (Alpha-2), згідно з ISO 3166-1, країни або території органу, що видав документ.",
    "german_id_description_issuing_jurisdiction" to "Код підрозділу країни юрисдикції, яка видала PID, згідно з ISO 3166-2:2020, пункт 8. Перша частина коду ПОВИННА відповідати значенню issuing_country.",
    "german_id_description_nationality" to "Список дволітерних кодів країн згідно з ISO 3166-1, що відображають громадянство користувача PID.",
    "german_id_description_older_than_12" to "Вік понад 12?",
    "german_id_description_older_than_14" to "Вік понад 14?",
    "german_id_description_older_than_16" to "Вік понад 16?",
    "german_id_description_older_than_18" to "Вік понад 18?",
    "german_id_description_older_than_21" to "Вік понад 21?",
    "german_id_description_older_than_65" to "Вік понад 65?",
    "german_id_description_place_of_birth" to "Країна та муніципалітет або штат/провінція, де народився власник PID",
    "german_id_description_resident_address" to "Повна адреса місця, де власник PID наразі проживає та/або з яким можна зв'язатися (вулиця/номер будинку, муніципалітет тощо).",
    "german_id_description_resident_city" to "Місто, де власник PID наразі проживає.",
    "german_id_description_resident_country" to "Країна, де користувач PID наразі проживає, у вигляді дволітерного коду країни згідно з ISO 3166-1.",
    "german_id_description_resident_postal_code" to "Поштовий індекс місця, де власник PID наразі проживає.",
    "german_id_description_state_of_birth" to "Штат, провінція, округ або місцевість, де народився користувач PID",
    "german_id_description_year_of_birth" to "Рік народження власника PID",
    "german_id_request_age_over_18" to "Вік старше 18",
    "german_id_request_all_data_elements" to "Усі елементи даних",
    "german_id_request_mandatory_data_elements" to "Обов'язкові елементи даних",
    "loyalty_attribute_date_of_expiry" to "Дата закінчення терміну дії",
    "loyalty_attribute_date_of_issue" to "Дата видачі",
    "loyalty_attribute_family_name" to "Прізвище",
    "loyalty_attribute_given_names" to "Ім'я, по батькові",
    "loyalty_attribute_membership_id" to "Номер членства",
    "loyalty_attribute_photo_of_holder" to "Фото власника",
    "loyalty_attribute_tier" to "Рівень",
    "loyalty_description_date_of_expiry" to "Дата закінчення терміну дії документа",
    "loyalty_description_date_of_issue" to "Дата видачі документа",
    "loyalty_description_family_name" to "Прізвище або основний ідентифікатор власника документа",
    "loyalty_description_given_names" to "Ім'я (імена) або вторинний ідентифікатор власника документа",
    "loyalty_description_membership_id" to "Ідентифікатор особи власника ідентифікатора програми лояльності.",
    "loyalty_description_photo_of_holder" to "Зображення портрета власника документа.",
    "loyalty_description_tier" to "Рівень членства (базовий, срібний, золотий, платиновий, елітний)",
    "loyalty_request_all_data_elements" to "Усі елементи даних",
    "loyalty_request_mandatory_data_elements" to "Обов'язкові елементи даних",
    "movie_ticket_attribute_age_rating_code" to "Код вікового рейтингу",
    "movie_ticket_attribute_cinema_theater" to "Кінотеатр",
    "movie_ticket_attribute_date_and_time_of_show" to "Дата та час сеансу",
    "movie_ticket_attribute_movie_poster" to "Постер фільму",
    "movie_ticket_attribute_movie_title" to "Назва фільму",
    "movie_ticket_attribute_parking" to "Парковка",
    "movie_ticket_attribute_seat" to "Місце",
    "movie_ticket_attribute_theater" to "Кінотеатр",
    "movie_ticket_attribute_ticket_number" to "Номер квитка",
    "movie_ticket_description_age_rating_code" to "Віковий рейтинг фільму",
    "movie_ticket_description_cinema_theater" to "Назва кінотеатру та/або його адреса/місце розташування.",
    "movie_ticket_description_date_and_time_of_show" to "Дата та час сеансу",
    "movie_ticket_description_movie_poster" to "Постер фільму",
    "movie_ticket_description_movie_title" to "Назва фільму та будь-яка інша інформація для ідентифікації сеансу.",
    "movie_ticket_description_parking" to "Чи передплачено паркування разом з квитком",
    "movie_ticket_description_seat" to "Номер або код місця (напр., ряд/місце)",
    "movie_ticket_description_theater" to "Назва або номер зали",
    "movie_ticket_description_ticket_number" to "Ідентифікаційний/довідковий номер квитка, виданий під час покупки.",
    "movie_ticket_request_all_data_elements" to "Усі елементи даних",
    "movie_ticket_request_prepaid_parking" to "Передоплачена парковка",
    "movie_ticket_request_ticket_number" to "Номер квитка",
    "naturalization_attribute_date_of_birth" to "Дата народження",
    "naturalization_attribute_date_of_naturalization" to "Дата натуралізації",
    "naturalization_attribute_family_name" to "Прізвище",
    "naturalization_attribute_given_names" to "Імена",
    "naturalization_description_date_of_birth" to "День, місяць і рік народження натуралізованої особи. Якщо невідомо, приблизна дата народження.",
    "naturalization_description_date_of_naturalization" to "Дата (та, можливо, час) натуралізації особи.",
    "naturalization_description_family_name" to "Поточне прізвище (прізвища) або основний ідентифікатор натуралізованої особи",
    "naturalization_description_given_names" to "Поточне ім'я (імена), інші імена або вторинний ідентифікатор натуралізованої особи",
    "naturalization_request_all_data_elements" to "Усі елементи даних",
    "payment_attribute_expiry_date" to "Термін дії",
    "payment_attribute_holder_name" to "Ім'я власника",
    "payment_attribute_issue_date" to "Дата видачі",
    "payment_attribute_issuer_name" to "Назва емітента",
    "payment_attribute_masked_account_reference" to "Маскований референс рахунку",
    "payment_attribute_payment_instrument_id" to "Ідентифікатор платіжного інструменту",
    "payment_description_expiry_date" to "Дата закінчення терміну дії цих облікових даних.",
    "payment_description_holder_name" to "Ім'я власника платіжного рахунку.",
    "payment_description_issue_date" to "Дата видачі цих облікових даних.",
    "payment_description_issuer_name" to "Читабельне ім'я емітента.",
    "payment_description_masked_account_reference" to "Маскований номер рахунку, наприклад, останні 4 цифри PAN.",
    "payment_description_payment_instrument_id" to "Ідентифікатор токенізованого платіжного інструменту.",
    "payment_request_payment_sca_all" to "SCA платежу (всі елементи даних)",
    "payment_request_payment_sca_minimal" to "SCA платежу (мінімальна)",
    "payment_request_payment_sca_transaction" to "SCA для оплати з платіжною транзакцією"
)
